export default "__VITE_ASSET__CDidca$k__"